/**
 * Hops database.
 */

export const HOPS = [
  // Aromahumle & IPA-favoriter
  {
    name: 'Citra',
    alpha_min: 11.0,
    alpha_max: 13.5,
    use: 'aroma',
    origin: 'US',
    desc: 'Intensiv tropisk frukt, mango, lime och persika. Kungen av IPA & NEIPA.',
  },
  {
    name: 'Mosaic',
    alpha_min: 11.5,
    alpha_max: 13.5,
    use: 'aroma',
    origin: 'US',
    desc: 'Komplex tropisk frukt, blåbär, citrus och örter. Extremt populär allrounder.',
  },
  {
    name: 'Simcoe',
    alpha_min: 12.0,
    alpha_max: 14.5,
    use: 'aroma',
    origin: 'US',
    desc: 'Passionsfrukt, tall, kåda och citrus. Favorit i West Coast IPA & NEIPA.',
  },
  {
    name: 'Cascade',
    alpha_min: 4.5,
    alpha_max: 7.0,
    use: 'dual',
    origin: 'US',
    desc: 'Grapefrukt, citrus och blommig arom. Den klassiska APA-humlen.',
  },
  {
    name: 'Centennial',
    alpha_min: 9.0,
    alpha_max: 12.0,
    use: 'dual',
    origin: 'US',
    desc: 'Citrus och blomster. "Super Cascade" för Pale Ale & IPA.',
  },
  {
    name: 'Amarillo',
    alpha_min: 8.0,
    alpha_max: 11.0,
    use: 'dual',
    origin: 'US',
    desc: 'Apelsin, persika och blommig sötma. Fruktig och mångsidig.',
  },
  {
    name: 'Chinook',
    alpha_min: 12.0,
    alpha_max: 14.0,
    use: 'dual',
    origin: 'US',
    desc: 'Barrträd, tall, jordnära och kraftfull ren beska.',
  },
  {
    name: 'Columbus / CTZ',
    alpha_min: 14.0,
    alpha_max: 16.5,
    use: 'dual',
    origin: 'US',
    desc: 'Kraftig beska, kryddig och örtig pepprighet.',
  },
  {
    name: 'Galaxy',
    alpha_min: 13.0,
    alpha_max: 15.5,
    use: 'aroma',
    origin: 'AU',
    desc: 'Passionsfrukt, citrus och persika. Australisk stjärnhumle.',
  },
  {
    name: 'Nelson Sauvin',
    alpha_min: 12.0,
    alpha_max: 14.0,
    use: 'aroma',
    origin: 'NZ',
    desc: 'Krusbär, vitvinstoner (Sauvignon Blanc) och grapefrukt.',
  },
  {
    name: 'Nectaron',
    alpha_min: 12.0,
    alpha_max: 14.5,
    use: 'aroma',
    origin: 'NZ',
    desc: 'Persika, nektarin, ananas och tropik. Eftertraktad nyazeeländare.',
  },
  {
    name: 'Superdelic',
    alpha_min: 9.0,
    alpha_max: 12.0,
    use: 'aroma',
    origin: 'NZ',
    desc: 'Röd frukt, mango, godis och fräsch citrus.',
  },
  {
    name: 'Sabro',
    alpha_min: 12.0,
    alpha_max: 15.0,
    use: 'aroma',
    origin: 'US',
    desc: 'Kokos, tropisk frukt, ceder och mynta. Unik smakprofil.',
  },
  {
    name: 'Talus',
    alpha_min: 8.0,
    alpha_max: 11.0,
    use: 'aroma',
    origin: 'US',
    desc: 'Pink grapefruit, torkade rosor, tall och tropisk frukt.',
  },
  {
    name: 'Idaho 7',
    alpha_min: 13.0,
    alpha_max: 15.0,
    use: 'aroma',
    origin: 'US',
    desc: 'Guava, apelsin, svart te och tall.',
  },
  {
    name: 'El Dorado',
    alpha_min: 13.0,
    alpha_max: 15.0,
    use: 'aroma',
    origin: 'US',
    desc: 'Vattenmelon, päron, godis och tropisk frukt.',
  },

  // Europeiska Ädel- & Lagerhumle
  {
    name: 'Saaz',
    alpha_min: 2.5,
    alpha_max: 4.5,
    use: 'aroma',
    origin: 'CZ',
    desc: 'Klassisk tjeckisk ädelhumle. Mild, kryddig och örtig pilsnerhumle.',
  },
  {
    name: 'Hallertau Mittelfrüh',
    alpha_min: 3.0,
    alpha_max: 5.5,
    use: 'aroma',
    origin: 'DE',
    desc: 'Fin blomster- och kryddarom. Klassisk tyska lagerhumle.',
  },
  {
    name: 'Tettnanger',
    alpha_min: 3.0,
    alpha_max: 5.5,
    use: 'aroma',
    origin: 'DE',
    desc: 'Mild, kryddig med lätt blomsterarom.',
  },
  {
    name: 'Spalter Select',
    alpha_min: 4.0,
    alpha_max: 6.0,
    use: 'aroma',
    origin: 'DE',
    desc: 'Delikat och ren örtig arom för lager och pilsner.',
  },
  {
    name: 'Perle',
    alpha_min: 6.0,
    alpha_max: 9.0,
    use: 'dual',
    origin: 'DE',
    desc: 'Fin kryddig arom och mjuk ren beska.',
  },
  {
    name: 'Magnum',
    alpha_min: 11.0,
    alpha_max: 14.5,
    use: 'bittering',
    origin: 'DE',
    desc: 'Ren neutral beskehumle. Låter aromahumlen tala fritt.',
  },
  {
    name: 'Hallertau Blanc',
    alpha_min: 9.0,
    alpha_max: 12.0,
    use: 'aroma',
    origin: 'DE',
    desc: 'Passionsfrukt, vindruvor, citrus. Modern tysk aroma.',
  },

  // Brittiska Humlesorter
  {
    name: 'Fuggles',
    alpha_min: 3.5,
    alpha_max: 6.0,
    use: 'dual',
    origin: 'UK',
    desc: 'Jordnära, örtlig, träig. Klassisk engelsk porter/bitter.',
  },
  {
    name: 'East Kent Goldings',
    alpha_min: 4.0,
    alpha_max: 6.5,
    use: 'aroma',
    origin: 'UK',
    desc: 'Silkeslen honungskrydda. Den brittiska klassikern för ales & stouts.',
  },

  // Svensk Kulturarvshumle
  {
    name: 'Svensk Korsta (SWE 25)',
    alpha_min: 7.0,
    alpha_max: 9.5,
    use: 'dual',
    origin: 'SE',
    desc: 'Svensk kulturarvshumle från Sundsvall (1769). Tropisk frukt, grapefrukt och friskt gräs.',
  },
  {
    name: 'Svensk Svalöf Mauritz 85',
    alpha_min: 3.0,
    alpha_max: 5.5,
    use: 'aroma',
    origin: 'SE',
    desc: 'Svensk förädlingshumle från Svalöv. Örtig, blommig och mild citrus.',
  },
];
